import React, { useEffect, useRef } from 'react';
import './Garden.css';

interface GardenInfoDialogProps {
  onClose: () => void;
}

const GardenInfoDialog: React.FC<GardenInfoDialogProps> = ({ onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div className="garden-plant-modal-overlay">
      <div
        ref={modalRef}
        className="garden-plant-modal"
      >
        <div className="garden-plant-note-popover-header">
          <div className="garden-plant-note-popover-title">
            <span className="garden-plant-note-popover-plant-type">
              Activity Score Info
            </span>
          </div>
          <button
            className="garden-plant-note-popover-close"
            onClick={onClose}
            title="Close"
          >
            ×
          </button>
        </div>

        <div className="garden-plant-note-popover-view">
          <div className="garden-plant-note-popover-content">
            <div className="garden-plant-activity-info">
              <div className="garden-plant-activity-description">
                <p>
                  Activity score is calculated from:
                </p>
                <ul>
                  <li>Completed tasks</li>
                  <li>Completed habits</li>
                  <li>Hours of scheduled blocks</li>
                </ul>
                <p>
                  Score 0-2: No plant<br />
                  Score 3-5: Small flower 🌸<br />
                  Score 6-9: Medium flower 🌺<br />
                  Score 10-15: Large flower 🌻<br />
                  Score 16+: Tree 🌳
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GardenInfoDialog;

